 

//------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated by a tool.
//
//     Changes to this file may cause incorrect behavior and will be lost if
//     the code is regenerated.
// </auto-generated>
//------------------------------------------------------------------------------

namespace Dataport.OD.ErhAnMiZuWohngeld.LegalNotice {
    export class LegalNoticeBase {
        Init() {
        }

        readonly LNPublisherSelector = "#LNPublisher";
        readonly PublisherInfoSelector = "#PublisherInfo";
        readonly LNLinebreak1Selector = "#LNLinebreak1";
        readonly LNResponsiblePartySelector = "#LNResponsibleParty";
        readonly ResponsiblePartyInfoSelector = "#ResponsiblePartyInfo";
        readonly LNLinebreak2Selector = "#LNLinebreak2";
        readonly LNRealizationSelector = "#LNRealization";
        readonly RealizationInfoSelector = "#RealizationInfo";

    }
   
    $(() => {
        const page = new LegalNoticeBase();
        page.Init();
    });
}



